import Vue from 'vue'
import master from '../masterModules/masterMutation.js'
// post-action
const URL = process.env.API_URL
const header = master.state.header

export default {
  checkedUsersAction(store, payload) {
    store.commit('reversedUsersCheck', payload)
  },
  inputUpdate(store, payload) {
    store.commit('inputUpdate', payload)
  },
  inputAddUpdate(store, payload) {
    store.commit('inputAddUpdate', payload)
  },
  clearPost(store) {
    store.commit('clearPost')
  },
  updateSelectedPostList(store, payload) {
    store.commit('updateSelectedPostList', payload)
  },
  clearSelectedPostList(store) {
    store.commit('clearSelectedPostList')
  },
  async addPost(store) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 300
    }
    const data = {
      header,
      data: [
        {
          posts: [store.state.addPost]
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/post/regist',
      data,
      config
    )
    // 成功
    // 追加後の処理
    store.commit('setPosts', response)
  },
  async setPosts(store, payload) {
    store.state.posts = []
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          posts: [],
          pageNo: payload.pageNo,
          count: 20,
          searchWord: payload.searchWord
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/post/list',
      data,
      config
    )
    // 成功
    store.commit('setPosts', response)
  },
  async setAllPosts(store) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          posts: []
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/post/list',
      data,
      config
    )
    // 成功
    store.commit('setAllPosts', response)
  },
  async updatePost(store, payload) {
    store.state.updatePost['users'] = payload
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 300
    }
    const data = {
      header,
      data: [
        {
          posts: [store.state.updatePost]
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/post/update',
      data,
      config
    )
    // 成功
    // 更新後の処理
    store.commit('setPosts', response)
  },
  async deletePosts(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 300
    }
    const data = {
      header,
      data: [
        {
          posts: payload
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/post/delete',
      data,
      config
    )
    // 成功
    // 削除後の処理
    store.commit('setPosts', response)
  },
  async setDetailPost(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          posts: [
            {
              postId: payload.postId
            }
          ]
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/post/detail',
      data,
      config
    )
    // 成功
    store.commit('setDetail', response)
  },
  async importPosts(store, payload) {
    let logContinue = true
    let pageNo = 0
    const count = 2000
    while (logContinue) {
      const config = {
        headers: {
          Authorization: master.state.authorization
        },
        timeout: 1000 * 300
      }
      const data = {
        header,
        data: [
          {
            posts: payload.slice(pageNo * count, pageNo * count + count),
            startFlag: pageNo === 0,
            endFlag: false
          }
        ]
      }

      const size = payload.length
      pageNo++
      if (size <= pageNo * count) {
        data.data[0].endFlag = true
        logContinue = false
      }

      await Vue.http.post(URL + '/v2/admin/post/import', data, config)
    }

    // 成功
    // 追加後の処理
    // store.commit('setDevices', response)
  },
  async setExportData(store, payload) {
    let logContinue = true
    let pageNo = 0
    const count = 2000
    const margeData = {
      data: {
        header: {},
        data: []
      }
    }
    let totalCount = 0
    while (logContinue) {
      const config = {
        headers: {
          Authorization: master.state.authorization
        },
        timeout: 1000 * 300
      }
      const data = {
        header,
        data: payload.selectedPostIdList.slice(
          pageNo * count,
          pageNo * count + count
        ),
        pageNo: payload.selectedPostIdList.length === 0 ? pageNo : 0,
        count: count,
        searchWord: payload.searchWord
      }
      var response = await Vue.http.post(
        URL + '/v2/admin/post/export',
        data,
        config
      )

      const size = response.data['data'].length
      totalCount += size
      for (let i = 0; i < size; i++) {
        margeData.data.data.push(response.data['data'][i])
      }
      pageNo++
      if (size < count) {
        margeData.data.header = response.data['header']
        logContinue = false
      }
      if (payload.selectedPostIdList.length > 0 && totalCount >= payload.selectedPostIdList.length) {
        margeData.data.header = response.data['header']
        logContinue = false
      }
    }

    // 成功
    // 追加後の処理
    store.commit('setExportData', margeData)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/belongModules/actions.js